import { t } from 'i18next';
import { prettyTx } from '@sovryn/ui';
import { BOB_CHAIN_ID, RSK_CHAIN_ID } from '../config/chains';
import { translations } from '../locales/i18n';
import { COMMON_SYMBOLS, findAsset, findAssetByAddress } from '../utils/asset';
export const getTokenDisplayName = (token, chainId = RSK_CHAIN_ID) => { var _a; return ((_a = findAsset(token, chainId)) === null || _a === void 0 ? void 0 : _a.symbol) || token.toUpperCase(); };
export const getTokenDisplayNameByAddress = (address, chainId = BOB_CHAIN_ID, fallbackPrettified = true) => {
    var _a;
    return ((_a = findAssetByAddress(address, chainId)) === null || _a === void 0 ? void 0 : _a.symbol) ||
        (fallbackPrettified ? prettyTx(address) : address);
};
export const getBobDeprecatedAssetTooltips = (asset) => {
    if (asset.toUpperCase() === COMMON_SYMBOLS.USDT0) {
        return {
            pool: t(translations.ambientMarketMaking.deprecatedTooltips.usdt.pool),
            convert: t(translations.ambientMarketMaking.deprecatedTooltips.usdt.convert),
        };
    }
    if (asset.toUpperCase() === COMMON_SYMBOLS.WBTC_OLD) {
        return {
            pool: t(translations.ambientMarketMaking.deprecatedTooltips.wbtc.pool),
            convert: t(translations.ambientMarketMaking.deprecatedTooltips.wbtc.convert),
        };
    }
    if (['POWA', 'DOGGOTOTHEMOON', 'PUPSWORLDPEACE'].includes(asset.toUpperCase())) {
        return {
            pool: 'Will be removed soon',
            convert: 'Convert',
        };
    }
};
export const getRskDeprecatedAssetTooltips = (asset) => {
    // if (asset.toUpperCase() === COMMON_SYMBOLS.RUSDT) {
    //   return {
    //     pool: t(translations.rusdtMigration.notice),
    //     convert: t(translations.rusdtMigration.convertNotice),
    //   };
    // }
    if (['POWA'].includes(asset.toUpperCase())) {
        return {
            pool: 'Will be removed soon',
            convert: 'Convert',
        };
    }
};
